import countries from "../data/europeMap.json";
import "../styles/coverage.css";

const destinations = [
  { id: "POL", code: "PL", x: 426, y: 351 },
  { id: "DEU", code: "DE", x: 315, y: 378 },
  { id: "SWE", code: "SE", x: 376, y: 167 },
  { id: "AUT", code: "AT", x: 361, y: 439 },
  { id: "DNK", code: "DK", x: 310, y: 285 },
  { id: "CHE", code: "CH", x: 291, y: 452 },
  { id: "CZE", code: "CZ", x: 378, y: 391 },
  { id: "NLD", code: "NL", x: 255, y: 350 },
  { id: "HUN", code: "HU", x: 429, y: 453 },
  { id: "ITA", code: "IT", x: 341, y: 525 },
  { id: "SVK", code: "SK", x: 435, y: 415 },
  { id: "FRA", code: "FR", x: 221, y: 450 },
  { id: "ESP", code: "ES", x: 147, y: 569 },
  { id: "HRV", code: "HR", x: 401, y: 505 },
  { id: "SVN", code: "SI", x: 369, y: 478 },
  { id: "FIN", code: "FI", x: 504, y: 137 },
  { id: "LTU", code: "LT", x: 479, y: 300 },
  { id: "LVA", code: "LV", x: 493, y: 270 },
  { id: "EST", code: "EE", x: 495, y: 238 },
];
const destinationIds = new Set(destinations.map(({ id }) => id));

export default function Coverage({ t }) {
  const copy = t.coverage;

  return (
    <section id="coverage" className="coverage-section" aria-labelledby="coverage-title">
      <div className="coverage-container">
        <div className="coverage-content">
          <p className="coverage-eyebrow">{copy.eyebrow}</p>
          <h2 id="coverage-title">{copy.title}</h2>
          <p className="coverage-intro">{copy.intro}</p>
          <ul className="coverage-countries">
            {destinations.map(({ id, code }) => (
              <li key={id}>
                <span className="coverage-country-flag" aria-hidden="true">
                  <img src={`/images/flags/${code}.svg`} alt="" width="30" height="20" />
                </span>
                {copy.countries[id]}
              </li>
            ))}
          </ul>
          <div className="coverage-invitation">
            <h3>{copy.invitationTitle}</h3>
            <p>{copy.invitation}</p>
            <a className="coverage-link" href="#contact">
              {copy.cta} <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>

        <figure className="coverage-map">
          <svg viewBox="0 0 720 684" role="img" aria-labelledby="coverage-map-title coverage-map-description">
            <title id="coverage-map-title">{copy.mapTitle}</title>
            <desc id="coverage-map-description">{copy.legend}: {destinations.map(({ id }) => copy.countries[id]).join(", ")}.</desc>
            <defs>
              <clipPath id="coverage-map-clip"><rect width="720" height="684" rx="24" /></clipPath>
            </defs>
            <g clipPath="url(#coverage-map-clip)">
              <rect width="720" height="684" fill="#edf4f9" />
              {countries.map(({ id, path }) => (
                <path key={id} d={path} className={destinationIds.has(id) ? "coverage-land coverage-land-active" : "coverage-land"} />
              ))}
              {destinations.map(({ id, code, x, y }) => (
                <g key={id} transform={`translate(${x} ${y})`} aria-hidden="true">
                  <rect x="-18" y="-13" width="36" height="26" rx="4" fill="#fff" />
                  <image href={`/images/flags/${code}.svg`} x="-15" y="-10" width="30" height="20" />
                </g>
              ))}
            </g>
          </svg>
          <figcaption>
            <span className="coverage-legend"><span aria-hidden="true" />{copy.legend}</span>
            <span className="coverage-source">{copy.source}</span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
